module.exports = require('./RatingAPILayer');



// WEBPACK FOOTER //
// ./src/react-rating.js